<template>
    <div>
        <div ref="crossword" id="crossword"></div>
    </div>
</template>

<style lang="scss">
@import '@/assets/css/crossword-old.scss';
</style>

<script>
import crossword_puzzle from '@/common/crossword'

export default {
    data: () => ({
        crossword: {},
        crossword_puzzle: crossword_puzzle,

        seed: 1,

        preview: false,
        filled_preview: false,

        loading: false
    }),
    props: [
        'publication_id',
        'unit_id'
    ],
    components: {

    },
    computed: {

    },
    methods: {
        getCrossword () {
            return new Promise((resolve, reject) => {
                this.axios.get('/api/units/crossword/' + this.unit_id)
                .then(response => {
                    if (response.data) {
                        if (response.data) {
                            this.crossword = response.data
                        }

                        if (this.crossword.vocab_data) {
                            this.crossword.vocab_data = _.orderBy(this.crossword.vocab_data, 'term')
                        }

                        if (
                            this.crossword.crossword_data &&
                            this.crossword.crossword_data.seed
                        ) {
                            this.seed = this.crossword.crossword_data.seed
                        }
                    }

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        generateCrossword () {
            this.reweaving_error = false

            this.term_description_pairs = []

            let crossword_node = document.getElementById('crossword')

            let seed = null

            if (
                this.crossword &&
                this.crossword.crossword_data.seed
            ) {
                seed = this.crossword.crossword_data.seed
            } else {
                seed = 1
            }

            let args = {
                node: crossword_node,
                separateDescriptions: true,
                subset: 18,
                allow_special_characters: false,
                seed: seed,
                preComplete: !this.preview || this.filled_preview,
                previewMode: this.preview,
                termDescriptionPairs: this.term_description_pairs
            }

            if (
                this.unit &&
                this.unit.crossword
            ) {
                _.forEach(this.unit.crossword.vocab_data, term => {
                    if (term.linked_to_crossword) {
                        this.term_description_pairs.push({
                            term: term.term,
                            term_id: term.vocabulary_term_id,
                            description: {
                                html: term.definition,
                                definition_id: term.definition_id
                            }
                        })
                    }
                })
            } else {
                _.forEach(this.crossword.vocab_data, term => {
                    if (term.linked_to_crossword) {
                        this.term_description_pairs.push({
                            term: term.term,
                            term_id: term.vocabulary_term_id,
                            description: {
                                html: term.definition,
                                definition_id: term.definition_id
                            }
                        })
                    }
                })
            }

            // Do not generate an empty crossword puzzle
            if (this.term_description_pairs.length > 0) {
                try {
                    this.my_crossword = new this.crossword_puzzle.Crossword(args)

                    let json = this.my_crossword.exportJSON()

                    if (json) {
                        json = JSON.parse(json)
                    }

                    if (!this.preview) {
                        this.saveCrossword(json)
                    }

                    this.reweaving = false

                    if (this.preview) {
                        crossword_node.classList.add('preview')

                        document.body.innerHTML = '';
                        document.body.appendChild(crossword_node)
                    } else {
                        crossword_node.classList.remove('preview')
                    }
                } catch {
                    this.reweaving = false
                    this.reweaving_error = true
                }
            } else {
                let json = null
                this.saveCrossword(json)

                this.reweaving = false
            }
        }
    },
    mounted () {
        if (this.$route.name === 'PreviewBlankCrossword') {
            this.filled_preview = false
            this.preview = true
        } else if (this.$route.name == 'PreviewFilledCrossword') {
            this.filled_preview = true
            this.preview = true
        }

        this.loading = true

        this.getCrossword()
        .then(() => {
            this.generateCrossword()

            this.loading = false
        })
    }
}
</script>
